import { render } from "./formtreeselectmulti.vue?vue&type=template&id=4b7a1ec4"
import script from "./formtreeselectmulti.vue?vue&type=script&lang=js"
export * from "./formtreeselectmulti.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\erenk\\source\\repos\\erenkorkmaz53\\eTalep\\eCampus\\eCampus.WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__